import { parseHtmlString } from "@/utils/helpers/html";
import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";


const WhoAreWe = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex flex-col gap-4 w-full">
        <div className="flex items-center gap-4 border-b border-b-gray">
          <Heading className="border-b border-b-wine-100" level={4} >{data.sectionTitle ?? "Default Title"}</Heading>
        </div>
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols[60%_1fr]">
          <img src={data.fileUrl ?? "/blank-image-placeholder.png" } alt={data.title ?? "Image"} className="w-full h-auto" />
          <div className="flex flex-col gap-2 p-4 bg-wine-100 text-white">
            <Heading level={5}>{data.title ?? "Default Subtitle"}</Heading>

            <Paragraph dangerouslySetInnerHTML={parseHtmlString(data.description ?? "Default Description")} />
          </div>
        </div>
      </div>
    </EditableSection>
  )
}

export default WhoAreWe